import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getHopDongState = state => state.hopDong;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.HOPDONG_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.HOPDONG_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function hopDongUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.HOPDONG_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function hopDongRemoveRequestApi(formData) {
  const request = axiosApi().post(
    Constants.HOPDONG_REMOVE_API,
    formData
  )

  return handleRequest(request);
}

function* hopDongListRequestFlow() {
  const hopDong = yield select(getHopDongState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, hopDong.formData)

    if (results.code != 200) {
      return yield put(brActions.hopDongListError(results.message))
    }
    // dispatch the action with our widgets!
    yield put(brActions.hopDongListSuccess(results.data))

  } catch (error) {
    yield put(brActions.hopDongListError(error))
  }
}

function* hopDongDetailRequestFlow() {
  const hopDong = yield select(getHopDongState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, hopDong.formData)

    if (results.code != 200) {
      return yield put(brActions.hopDongDetailError(results.message))
    }
    yield put(brActions.hopDongDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.hopDongDetailError(error))
  }
}

function* hopDongUpdateRequestFlow(action) {
  const hopDong = yield select(getHopDongState);
  try {
    // grab the client from our action
    const result = yield call(hopDongUpdateRequestApi, hopDong.formData)

    if (result.code != 200) {
      return yield put(brActions.hopDongUpdateError(result.message))
    }
    yield put(brActions.hopDongUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.hopDongUpdateError(error))
  }
}

function* hopDongRemoveRequestFlow(action) {
  const hopDong = yield select(getHopDongState);
  try {
    // grab the client from our action
    const result = yield call(hopDongRemoveRequestApi, hopDong.formData)
    // dispatch the action with our widgets!
    if (result.code != 200) {
      return yield put(brActions.hopDongRemoveError(result.message))
    }
    yield put(brActions.hopDongRemoveSuccess(result));
    if (typeof hopDong.callback == 'function') {
      yield call(hopDong.callback, result);
    }
  } catch (error) {
    yield put(brActions.hopDongRemoveError(error))
  }
}

function* hopDongWatcher() {
  yield [
    takeLatest(Constants.HOPDONG_LIST_REQUESTING, hopDongListRequestFlow),
    takeLatest(Constants.HOPDONG_DETAIL_REQUESTING, hopDongDetailRequestFlow),
    takeLatest(Constants.HOPDONG_UPDATE_REQUESTING, hopDongUpdateRequestFlow),
    takeLatest(Constants.HOPDONG_REMOVE_REQUESTING, hopDongRemoveRequestFlow),
  ]
}

export default hopDongWatcher



// WEBPACK FOOTER //
// ./src/views/HopDong/sagas.js